export const allowedDomain = ['app.prophecy.io', 'app.prophecy.ai'];
export const UTM_SESSION_KEY = 'prophecy_utm_params_session';
export const UTM_COOKIE_NAME = 'prophecy_utm_params';

export const UTM_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'hsa_acc',
  'hsa_cam',
  'hsa_grp',
  'hsa_ad',
  'hsa_net',
  'hsa_ver',
  'li_fat_id',
  'gclid',
  'gad_source'
] as const;
